import { Component, Mixins, Prop } from 'vue-property-decorator';
import addKeywordSuggestionsMutation from '../../mutations/addKeywordSuggestion';
import keywordSuggestionsQuery from '../../queries/keywordSuggestionsQuery';
import { UtilMixin } from '../../UtilMixin';
import SingleMainContainer from '../shared/singleMainContainer.vue';
import BooksCarousel from './booksCarousel.vue';

@Component({ components: { BooksCarousel, SingleMainContainer } })
export default class SuggestionsListKeywordsAdder extends Mixins(UtilMixin) {
  @Prop() public suggestionsList!: any;

  public readonly keywordQuery = keywordSuggestionsQuery;

  public readonly keywordMutation = addKeywordSuggestionsMutation;

  public getMutationVariablesForKeyword(suggestionCandidate: any) {
    console.log(JSON.stringify(suggestionCandidate));
    return {
      suggestionsListId: this.suggestionsList.id,
      keyword: suggestionCandidate.source.keyword,
      publicationUrl: this.findSelfUrl(suggestionCandidate.publication),
    };
  }
}
